import './i18n';
import React from "react";
import ReactDOM from "react-dom/client";
import AppRouter from "./AppRouter";

// All three apps (compliance, training, nexusguard) are loaded based on URL
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>
);